import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
import isoWeek from "dayjs/plugin/isoWeek"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import relativeTime from "dayjs/plugin/relativeTime"
// core
import { createApp } from "vue"

import App from "@/App.vue"
// load
import { loadDirectives } from "@/directives"
import { startLocalPrintTaskPoller } from "@/features/printing/localPrintTaskPoller"
import { loadSvg } from "@/icons"
import { loadPlugins } from "@/plugins"
import router from "@/router"
import store from "@/store"
import { preventUnhandledBusinessContextCancellation } from "@/utils/businessContext/authFailure"
import { installBusinessContextDiagnostics } from "@/utils/businessContext/diagnostics"
import { REPO_MOCK_SERVER_PREFIX, unregisterRepoMockServiceWorkers } from "@/utils/repoMock"
import "dayjs/locale/zh-cn"
// import pkg from "../package.json"
// css
import "uno.css"
import "element-plus/dist/index.css"
import "element-plus/theme-chalk/dark/css-vars.css"
import "@repo/ui/tokens/tea-shop.css"
// JZTODO 不支持跳转
import "@/styles/index.scss"

dayjs.extend(isoWeek)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(duration)
dayjs.extend(relativeTime)

installBusinessContextDiagnostics()

const app = createApp(App)

window.addEventListener(
  "unhandledrejection",
  preventUnhandledBusinessContextCancellation,
)

const errorHandler = (err: any) => {
  // 忽略 Element Plus el-tabs 的已知 bug（非致命错误）
  // https://github.com/element-plus/element-plus/issues - unregisterPane indexOf undefined
  if (err?.message?.includes("Cannot read properties of undefined (reading 'indexOf')") &&
    err?.stack?.includes('unregisterPane')) {
    console.warn('[Element Plus] 忽略 el-tabs unregisterPane 已知问题')
    return
  }

  try {
    console.error(JSON.stringify(err) || "网络异常，请稍后尝试")
  } catch (error) {
    console.error(error)
  }
  console.error(err)
}

app.config.errorHandler = (err: any) => {
  errorHandler(err)
}
window.onerror = (err) => {
  errorHandler(err)
}

const repoStaticMockEnabled = import.meta.env.VITE_MOCK === "true" && import.meta.env.VITE_MOCK_MODE === "static"

function cleanupRepoStaticMocking() {
  unregisterRepoMockServiceWorkers().catch((err) => {
    console.warn("清理 repo mock service worker 失败", err)
  })
}

async function enableRepoStaticMocking() {
  if (!repoStaticMockEnabled) {
    cleanupRepoStaticMocking()
    return
  }

  const { enableStaticMocking } = await import('@repo/mock-server/static-browser')
  await enableStaticMocking({
    prefix: REPO_MOCK_SERVER_PREFIX,
  })
}

async function bootstrap() {
  await enableRepoStaticMocking()

  /** 加载插件 */
  loadPlugins(app)
  /** 加载全局 SVG */
  loadSvg(app)
  /** 加载自定义指令 */
  loadDirectives(app)

  dayjs.locale("zh-cn")

  app.use(store)
  await import("@/router/permission")
  app.use(router).mount("#app")
  startLocalPrintTaskPoller()
}

bootstrap().catch((err) => {
  errorHandler(err)
})
